import { Validator } from 'vee-validate'
import basicinformation from './basicinformation/index.vue';
import detailedinformation from './detailedinformation/index.vue';
import CryptoJS from 'crypto-js';
import VueElementLoading from 'vue-element-loading';
import jsPDF from 'jspdf';
import Printd from 'printd';
import LRCopy from './../../LRCopy';
import printmps from './../../printmps';
import BookingService from '../../../../services/cargobooking.service'
import TripServices from './../../../../../firstAndLastmilemanagement/services/firstAndLastmilemanagement.service';
import Util from './../../../../../shared/util/util';
import Report from './../../../../../report/services/report.service';
import moment from 'moment';

export default {
	name: 'Booking',
	components: {
    'first': basicinformation,
    'second': detailedinformation,
		LRCopy,
		printmps
	},
	props: ['bookingData'],
	data() {
		return {
		currentTab: 'First',
		componentKey:1,
		tabs: [
			{ key:'First', value:'Basic Information' },
			{ key:'Second', value:'Detailed Information' },
		],
		isLoading: false,
		PrintMPSModal: false,
		clientname:'',
		awbnumber:'',
		selectedViewRowData:[],
		FtcModal:false,
		uploadFile:'',
		filename:'',
		uploadedDoc:'',
		allowimageupload:false,
		showCashMemoButton:false,
		downloadmessage:"(Click on the download icon to download)",
		LRCopyawbdata: null,
		openViewRateCard : false,
      	rateCardData:'',
		totalcharges:'',
     	gst:''
		}
	},
	created: function() {

	},
	computed: {
    currentTabComponent: function () {
      this.componentKey += 1;
      return this.currentTab.toLowerCase();
    }
	},
	mounted() {
		var userdetailEncrypt = window.localStorage.getItem('cargoAutoaccessuserdata')
		var bytes = CryptoJS.AES.decrypt(userdetailEncrypt.toString(), 'Key');
		var plaintext = bytes.toString(CryptoJS.enc.Utf8);
		var userdetail = JSON.parse(plaintext);
		this.userName = userdetail.email;
		this.hubname = userdetail.currentHubName;
		this.hubid = userdetail.hubID[0];
		this.userid = userdetail.userid;
		this.useremail = userdetail.email;
	},
	methods: {
		async setValues(selectedViewRowData){
			this.selectedViewRowData = selectedViewRowData;
			this.clientname = selectedViewRowData.clientname;
			this.awbnumber = selectedViewRowData.awbnumber;			if (this.selectedViewRowData.bookingmode == 'To Pay') {
				this.getFTCCashmemoDetails()
		  	}
			  if (this.selectedViewRowData.bookingmode == 'PrePaid' && this.selectedViewRowData.routemode == 'Air' && this.selectedViewRowData.awbnumber) {
				this.rateCardData = this.selectedViewRowData.prepaidratebreakup
				this.totalcharges = this.rateCardData.rate.basefreight
				+ this.rateCardData.rate.originterminalcharges
				+ this.rateCardData.rate.destinationterminalcharges
				+ this.rateCardData.rate.originoperatorcharges
				+ this.rateCardData.rate.destinationoperatorcharges
				+ this.rateCardData.rate.othercharges
				+ this.rateCardData.rate.extracharges

				 this.gst = this.totalcharges / 100 *this.rateCardData.rate.gst ;
			  }

		 	await this.getawbdetails();
			this.$nextTick(() => {
				this.$refs.childBookingViewComponent && this.$refs.childBookingViewComponent.setValues(this.selectedViewRowData);
			})
		},
		printAWBPage() {
			const d = new Printd();
			var buffer = '';

			var cssText = `
					 body{
							 -webkit-print-color-adjust:exact;
							 font-family: Roboto,sans-serif;
							 font-size:20%;
					 }
					 table {
							 border-collapse: collapse;
							 margin-left:0px !important;
					 }
					 table, td, th {
						 border-style: solid;
						 border-width: 1px;
						 padding:5px;
					 }
					 .text-right{
						 text-align:right;
					 }
					 .text-left{
						 text-align:left;
					 }
					 .text-center{
						 text-align:center;
					 }
					 .h3-center-text{
						 text-align:center;
					 }
					 @media print {
					 .text-primary th{
						 background-color:rgb(226, 216, 216) !important;
						 color:black !important;
						 font-size:20px !important;
					 }
					}
					@media print {
					.pagebreak {
					page-break-after: always;
					}
					}
					`
			d.print(document.getElementById('printAWBData'), cssText);
		},
		DownloadAWB(){
			const doc = new jsPDF('p', 'pt', 'a2');
      const contentHtml = document.getElementById('printData');
			var handleElement = {
			    '#elementH': function (element, renderer) {
			        return true;
			    }
			};
			doc.html(contentHtml, {
			  'x': 15,
			  'y': 15,
			  'width': 170,
			  'elementHandlers': handleElement
			});
      doc.save("awbdetails.pdf");
		},
		PrintAWB(){
			const d = new Printd();
      var buffer = '';
			var cssText = `
           body{
               -webkit-print-color-adjust:exact;
               font-family: Roboto,sans-serif;
           }
           table {
               border-collapse: collapse;
               margin-left:0px !important;
           }
           table, td, th {
             border-style: solid;
             border-width: 1px;
             padding:5px;
           }
           .text-right{
             text-align:right;
           }
           .text-left{
             text-align:left;
           }
           .text-center{
             text-align:center;
           }
           .h3-center-text{
             text-align:center;
           }
           @media print {
           .text-primary th{
             background-color:rgb(226, 216, 216) !important;
             color:black !important;
             font-size:20px !important;
           }
          }
          `
      d.print(document.getElementById('printData'), cssText);
		},
		openPrintMPSModal(){
       this.PrintMPSModal = true;
    },
    closePrintMPSModal(){
       this.PrintMPSModal = false;
    },
	async UploadFtcCashMemo (event){
		try{
		this.uploadFile = event.target.files[0];
		this.filename = event.target.files[0].name;
			let formData = new FormData();
			  if (this.uploadFile.size > (1024 * 1024 * 6)) {
				this.$alert(`Uploaded file size is greater than 6000KB`, "", "error");
				this.isLoading = false
				return false
			  }
			  this.$refs.files.value=null;
		  }
		  catch(err){
			  this.isLoading = false
			  console.log(err)
			}
		  },
	async SaveFtcCashMemo (){
	  try{
		let uploadformData = new FormData();
		this.isLoading = true
		  uploadformData.append("file", this.uploadFile);
		  uploadformData.append("awbnumber", this.selectedViewRowData.awbnumber);

		let uploadresult = await BookingService.UploadFtcCashMemo(uploadformData)
		if (uploadresult.data.errorCode == 0) {
		  this.uploadedDoc = uploadresult.data.data
		  // this.$alertify.success("Document uploaded successfully");
		  let formData = new FormData();
		  formData.append("awbnumber", this.selectedViewRowData.awbnumber);
		  formData.append("ftccashmemo", this.uploadedDoc);
		let result = await BookingService.SaveFtcCashMemo(formData)
		if (result.data.code = 200) {
		  this.$alertify.success("Document Saved successfully");
		}
		else{
		  this.$alertify.error("Failed to save document.");
		  this.isLoading = false
		}
		this.isLoading = false
		}
		else{
		  this.$alertify.error("Document could not be uploaded.");
		  this.isLoading = false
		}
	}
  catch(err){
	  this.isLoading = false
	  console.log(err)
	}
  },
  async getFTCCashmemoDetails(){
	try{
	  this.isLoading = true
	  let inputPayload = {}
	  inputPayload.awb =  this.selectedViewRowData.awbnumber;
	  inputPayload.handovercheck =  this.selectedViewRowData.pickbyclient;
	  let result = await BookingService.getFTCCashmemoDetails(inputPayload)
	  console.log(result.data.code );
	  if (result.data.code == 200) {
		if (result.data.message.iscashpayment == 0) {
		  this.showCashMemoButton = false
		}else{
		  this.showCashMemoButton = true
		  if (result.data.message.cashmemoarray && result.data.message.cashmemoarray.length>0 ) {
			this.uploadedDoc = result.data.message.cashmemoarray[0]
		  }else{
			if (this.selectedViewRowData.pickbyclient == 0) {
			  this.downloadmessage = "Cash Memo Not Uploaded"
			}else{
			this.allowimageupload = true
			}
		  }
		}
	  }
	  this.isLoading = false
  }
  catch(err){
	this.isLoading = false
	console.log(err)
  }
  },

	fileview(index){
	  console.log(this.uploadFile);
	  var link = document.createElement('a');
	  link.href = index;
	  link.setAttribute('target','_blank');
	  window.open(index, '_blank');
	  link.remove();
	  return true;
	},
	openFtcModal(){
		if (this.bookingData.ftccashmemo) {
		  this.uploadedDoc = this.selectedViewRowData.ftccashmemo
		}
		 this.FtcModal = true;
	  },
	  clearFtcModal(){
		 this.uploadFile = '';
		 this.filename = '';
		 this.uploadedDoc = '';
		 this.$refs.files.value=null;
	  },
	  closeFtcModal(){
		this.FtcModal = false;
	 },
	 async getawbdetails(){
		 try {
			let payload = {
				'awb': [this.awbnumber]
			  }
				let printMultipleAwbsLogs = [];
		    let dt = moment().tz('Asia/Kolkata').format('DD-MM-YYYY HH:mm:ss');
			  let result = await TripServices.getAWBDetailsForLRCopy(payload);

			  if(result.data.code == 200){
				let awbdetails = result.data.data.awbdetails;
				let hubdetails = result.data.data.hubdetails;
				let inputPayload ={}
				if(awbdetails.length > 0){
				  for(const item of awbdetails){
					let pickupTime = "";
					if(item.PickupDetails.SlotsTime.From){
					   pickupTime=item.PickupDetails.SlotsTime.From.slice(0,2)+":"+ item.PickupDetails.SlotsTime.From.slice(2,4)
					}

					let originhub;
					let destinationhubs;
					hubdetails.forEach(hubitem=>{
					  if(item.OriginHubID==hubitem.HubID){
						originhub=hubitem.HubName;
					  }
					  if(item.DestinationHubId==hubitem.HubID){
						destinationhubs=hubitem.HubName
					  }
					});

					//get sku dimensions list
					let dim = [];
					let qty = [];
					for(let i=0; i<5; i++){
						if(item.enabledimensionvisibilitylrcopy && item.SKUDetails && item.SKUDetails[i] && item.SKUDetails[i].BoxDimensions && item.clienttype!="SalesFranchise"){
							dim.push(item.SKUDetails[i].BoxDimensions);
						}else{
							dim[i] = "";
						}
						if(item.enabledimensionvisibilitylrcopy && item.SKUDetails && item.SKUDetails[i] && item.SKUDetails[i].NoOfBoxes && item.clienttype!="SalesFranchise"){
							qty.push(item.SKUDetails[i].NoOfBoxes);
						}else{
							qty[i] = "";
						}
					}

					let awbCustomiseData = {
						"referenceno":item.referenceno,
						"ConsigneeCode":item.DropDetails.Addresses[0].ConsigneeCode,
						"consigneename":item.DropDetails.Addresses[0].Name,
						"ConsigneePOC":item.DropDetails.Addresses[0].Attn,
						"PickupLocation":item.PickupDetails.Addresses[0].Name,
						"ClientReferenceNo":item.ClientReferenceNo,
						"InvoiceNumber":item.InvoiceNumber,
						"ebn":item.ebn,
						"ConsigneeAddress":item.DropDetails.Addresses[0].Address,
						"PickupItemCount":(item.vtcamount)?item.vtcamount:""
					}
					this.LRCopyawbdata = {
						"awbnumber":item.parentawb,
						"originhub":null,
						"originhubid":item.OriginHubID,
						"destinationhubs":null,
						"destinationhubid":item.DestinationHubId,
						"clientid":item.ClientID,
						"clientbusinessacountid":item.clientbusinessacountid,
						"reliancesecondaryclient":item.reliancesecondaryclient,
						"businessaccountname":item.BusinessAccountName,
						"pickupname":item.PickupDetails.Addresses[0].Name,
						"pickupaddress":item.PickupDetails.Addresses[0].Address,
						"pickupcity":item.PickupDetails.Addresses[0].City,
						"pickuppincode":item.PickupDetails.Addresses[0].PinCode,
						"pickupmobile":item.PickupDetails.ContactDetails[0].PhoneNo,
						"pickupgst":item.PickupDetails.Addresses[0].TINNo,
						"pickupemail":item.PickupDetails.Addresses[0].EmailID,
						"requestedpickupdate":Util.displayDateOnlyFormat(item.PickupDetails.PickupSlotsDate),
						"requestedpickuptimefrom":pickupTime,
						"consingneecode":item.DropDetails.Addresses[0].ConsigneeCode,
						"consingneename":item.DropDetails.Addresses[0].Name,
						"consingneeattn":item.DropDetails.Addresses[0].Attn,
						"consingneeaddress":item.DropDetails.Addresses[0].Address,
						"consingneecity":item.DropDetails.Addresses[0].City,
						"destinationpincode":item.DropDetails.Addresses[0].PinCode,
						"consingneemobile":item.DropDetails.ContactDetails[0].PhoneNo,
						"consingneecsttin":item.DropDetails.Addresses[0].TINNo,
						"consingneeemail":item.DropDetails.Addresses[0].EmailID,
						"numberofmps":item.NumberOfMPS,
						"totalshipmentvalues":item.TotalInvoiceValue,
						"totalphysicalweight":item.totalphysicalweight,
						"totalvolumetricweight":item.VolumetricWeight,
						"bookingmode":item.BookingMode,
						"clientrefnumber":item.ClientReferenceNo,
						"refnumber":item.referenceno,
						"dropbyclient":item.isshipmentdroptohubbyclient == 1?1:0,
          	"pickbyclient":item.isselfcollectbyclient == 1?1:0,
						"ebn":item.ebn,
						"originhub":originhub,
						"destinationhubs":destinationhubs,
						"clienttype": item.clienttype,
						"clientweightdisabledflag":item.clientweightdisabledflag,
						"awbcopydata": awbCustomiseData,
						"enabledimensionvisibilitylrcopy":item.enabledimensionvisibilitylrcopy,
						"skuboxdimensions": dim,
						"skuboxquantity": qty,
						"bookingsource" : item.bookingsource
					  }
						let awblogs ={
							AWBNo: item.parentawb,
							loggedinhubid : this.hubid,
							userid : this.userid,
							useremail : this.useremail,
							hubName: this.hubname,
							createdDate:dt,
							sourceType: "Web"
						}
						printMultipleAwbsLogs.push(awblogs);
					};
					inputPayload.awblogs=printMultipleAwbsLogs
					let printawblogsresult= await Report.printawblogs(inputPayload);
				  }else{
					this.$alert("No Valid AWB(s) details found","","error");
				  }
			  }else{
				this.$alert("No Valid AWB(s) details found","","error");
			  }
			  this.isLoading=false;
		 } catch (error) {
			this.isLoading = false
			console.log(error)
		 }

	 }
	}
}



// WEBPACK FOOTER //
// ./src/modules/cargobooking/views/booking/bookingListing/bookingview/bookingview.component.js